/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react"
import { format } from "date-fns"
import { Doughnut, HorizontalBar } from "react-chartjs-2"
import "chartjs-plugin-datalabels"
import Select from "react-select"
import { getRequest } from "utils/request"

import "./style.css"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"

import { i18n } from "../../../translate/i18n"

import { CircularProgress } from "@material-ui/core"
import { useModal } from "hooks/modal"
import getFile from "utils/download"

export default function ReportByDepartment() {
  const [loading, setLoading] = useState(false)
  const [beginDate, setBeginDate] = useState(
    format(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      "yyyy-MM-dd"
    )
  )
  const [endDate, setEndDate] = useState(
    format(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      "yyyy-MM-dd"
    )
  )
  const [listCompanies, setListCompanies] = useState([])
  const [companies, setCompanies] = useState([])
  const [table, setTable] = useState([])
  const [data, setData] = useState()
  const [search, setSearch] = useState(false)
  const [companyNickName, setCompanyNickName] = useState(false)
  const [globalFilter, setGlobalFilter] = useState("")
  const [loadingPDFDownload, setLoadingPDFDownload] = useState(false)
  const [loadingXLSDownload, setLoadingXLSDownload] = useState(false)
  const { toggleHelperId } = useModal()

  const colorsBar = [
    "#681E99",
    "#6F2384",
    "#A753A9",
    "#AC8CC8",
    "#2DB2BC",
    "#70C5CB",
    "#C04949",
    "#F75858",
    "#5A6891",
    "#F0B700",
    "#F5CC63",
    "#FFF8CA",
  ]

  const loadCompanies = async () => {
    setLoading(true)
    //BUSCA PERFIS DISPONIVEIS
    const ReturnGet = await getRequest(`/userscompanies`)
    if (ReturnGet.success) {
      let opt = []
      ReturnGet.data.map((data) => {
        opt.push({ value: data.id, label: data.nickName })
      })
      setListCompanies(opt)
      setLoading(false)
    }
  }

  const download = (type) => {
    if (type === 1) {
      setLoadingPDFDownload(true)
    } else if (type === 2) {
      setLoadingXLSDownload(true)
    }
    let statusquery = ""
    companies.map((data) => {
      statusquery = `${statusquery}&CompanyId=${data.value}`
    })
    getRequest(
      `${process.env.REACT_APP_API_URL}/reports/export?reportId=7&${statusquery}&typeId=${type}&beginDate=${beginDate}&endDate=${endDate}`,
      type === 1 ? "pdf" : "xlsx",
      "report"
    ).then((e) => {
      setTimeout(() => {
        if (e.success) {
          getFile(
            e.data.message ?? "",
            type === 1 ? "pdf" : "xlsx",
            i18n.t("perDepartment")
          )
        }
        if (type === 2) {
          setLoadingXLSDownload(false)
        } else if (type === 1) {
          setLoadingPDFDownload(false)
        }
      }, 2000)
    })
  }

  useEffect(() => {
    loadCompanies()
    toggleHelperId(7)
  }, [])

  const handleChangeCompanies = (e) => {
    setCompanies([])
    setSearch(false)

    if (e != null) {
      setCompanies(e)
    }
  }

  const ChartbyCompanies = (items) => {
    var lookup = {}
    var companies = []
    var kpis = []
    var kpisBar = []
    var name

    for (var item, i = 0; (item = items[i++]); ) {
      name = item.nickName

      if (!(name in lookup)) {
        lookup[name] = 1
        companies.push(name)
      }
    }

    for (item, i = 0; (item = items[i++]); ) {
      name = item.kpi

      if (!(name in lookup)) {
        lookup[name] = 1
        kpis.push(name)
      }
    }

    let iColor = 0
    kpis.forEach((kpi) => {
      var values = []
      companies.forEach((company) => {
        var kpiBar = items.filter(
          (element) => element.kpi === kpi && element.nickName === company
        )

        if (kpiBar.length > 0) {
          kpiBar.forEach((usertype) => {
            values.push(usertype.quantity)
          })
        } else {
          values.push(0)
        }
      })

      kpisBar.push({
        label: kpi,
        backgroundColor: colorsBar[iColor],
        borderColor: "#FFFFFF",
        borderWidth: 1,
        stack: 1,
        // hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        // hoverBorderColor: 'rgba(255,99,132,1)',
        data: values,
      })

      iColor++
    })

    setData({
      labels: companies,
      datasets: kpisBar,
    })
  }

  const ChartbyCompany = (items) => {
    var lookup = {}
    var companies = []
    var kpis = []
    var name

    for (var item, i = 0; (item = items[i++]); ) {
      name = item.nickName

      if (!(name in lookup)) {
        lookup[name] = 1
        companies.push(name)
      }
    }

    setCompanyNickName(companies[0])

    for (item, i = 0; (item = items[i++]); ) {
      name = item.kpi

      if (!(name in lookup)) {
        lookup[name] = 1
        kpis.push(name)
      }
    }

    var values = []

    kpis.forEach((kpi) => {
      var kpiBar = items.filter((element) => element.kpi === kpi)
      kpiBar.forEach((department) => {
        values.push(department.quantity)
      })
    })

    setData({
      labels: kpis,
      datasets: [
        {
          backgroundColor: colorsBar,
          borderColor: "#FFFFFF",
          borderWidth: 1,
          data: values,
        },
      ],
    })
  }

  const handlerSendSearch = async () => {
    setLoading(true)

    let statusquery = ""
    companies.map((data) => {
      statusquery = `${statusquery}&CompanyId=${data.value}`
    })

    //BUSCA DADOS DO RELATORIO
    const ReturnGet = await getRequest(
      `/reports/getbydepartment?${statusquery}&beginDate=${beginDate}&endDate=${endDate}`
    )
    if (ReturnGet.success) {
      setTable(ReturnGet.data)
      if (companies.length > 1) {
        ChartbyCompanies(ReturnGet.data)
      } else {
        ChartbyCompany(ReturnGet.data)
      }
      setSearch(true)
      setLoading(false)
    }
  }

  const options = {
    responsive: true,
    legend: {
      display: true,
    },
    type: "pie",
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
        },
      ],
    },
    plugins: {
      datalabels: {
        display: true,
        color: "black",
      },
    },
  }

  const options2 = {
    responsive: true,
    legend: {
      display: false,
    },
    type: "pie",
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
        },
      ],
    },
    plugins: {
      datalabels: {
        display: true,
        color: "black",
      },
    },
  }

  const header = (
    <div className="data-table-header">
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  )

  return (
    <div style={{ overflowY: "auto" }}>
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h3>{i18n.t("perDepartment")}</h3>
            <form
              className="form-edit"
              onSubmit={(e) => {
                e.preventDefault()
                handlerSendSearch()
              }}
            >
              <div className="col-lg-12">
                <div className="form-row mt-2">
                  <div className="form-group col-md-3">
                    <label> {i18n.t("startDate")} *</label>
                    <input
                      type="date"
                      className="form-control"
                      defaultValue={beginDate || ""}
                      required
                      onChange={(value) => setBeginDate(value.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label> {i18n.t("endDate")} *</label>
                    <input
                      type="date"
                      className="form-control"
                      defaultValue={endDate || ""}
                      required
                      onChange={(value) => setEndDate(value.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label> {i18n.t("company") + "s"} *</label>
                    <Select
                      options={listCompanies}
                      placeholder={`Seleciona as empresas`}
                      isMulti={true}
                      getStyles="select2 form-control select2-multiple"
                      value={companies || ""}
                      onChange={handleChangeCompanies}
                    />
                  </div>
                  <div className="form-group col-md-2">
                    <label>&nbsp;</label>
                    <button
                      type="submit"
                      className="form-control btn btn-outline-success"
                      disabled={companies.length === 0}
                    >
                      <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                      {i18n.t("search")}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="col-12">
        {!loading && (
          <div className="card">
            <div className="card-body">
              {search ? (
                <div className="row">
                  {companies.length > 1 ? (
                    <div className="col-6">
                      <HorizontalBar
                        data={data}
                        width={null}
                        height={null}
                        options={options}
                      />
                    </div>
                  ) : (
                    <div className="col-6">
                      <h3>{companyNickName}</h3>
                      <Doughnut
                        data={data}
                        width={null}
                        height={null}
                        options={options2}
                      />
                    </div>
                  )}
                  <div className="col-6" style={{ overflowY: "auto" }}>
                    <div className="export-buttons">
                      <>
                        {!loadingXLSDownload ? (
                          <Button
                            disabled={loadingPDFDownload}
                            onClick={() => download(2)}
                            type="button"
                            style={{
                              backgroundColor: "green",
                              marginRight: 30,
                              height: 40,
                            }}
                          >
                            <i
                              className="far fa-file-excel"
                              style={{ fontSize: 25, marginRight: 5 }}
                            ></i>
                            Exportar
                          </Button>
                        ) : (
                          <div
                            style={{
                              height: 40,
                              width: 116,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress
                              className="loading-download"
                              size={20}
                            />
                          </div>
                        )}
                      </>
                      {!loadingPDFDownload ? (
                        <Button
                          disabled={loadingXLSDownload}
                          onClick={() => download(1)}
                          type="button"
                          style={{ backgroundColor: "red", height: 40 }}
                        >
                          <i
                            className="far fa-file-pdf"
                            style={{ fontSize: 25, marginRight: 5 }}
                          ></i>{" "}
                          Exportar
                        </Button>
                      ) : (
                        <div
                          style={{
                            height: 40,
                            width: 116,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress
                            className="loading-download"
                            size={20}
                          />
                        </div>
                      )}
                    </div>
                    {!loading ? (
                      <DataTable
                        header={header}
                        dataKey="id"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        value={table}
                        globalFilter={globalFilter}
                        paginator
                        rows={5}
                        emptyMessage={i18n.t("noInfoFinded")}
                      >
                        <Column
                          field="nickName"
                          header={i18n.t("company")}
                          sortable
                        ></Column>
                        <Column
                          field="kpi"
                          header={i18n.t("department")}
                          sortable
                        ></Column>
                        <Column
                          field="quantity"
                          header={i18n.t("quantity")}
                          sortable
                        ></Column>
                      </DataTable>
                    ) : (
                      <CircularProgress />
                    )}
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
